import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SearchComponent } from '../../components/list-work-orders/search/search.component';
import { WorkOrderGridComponent } from '../../components/list-work-orders/work-order-grid/work-order-grid.component';
import { FiltersComponent } from '../../components/list-work-orders/filters/filters.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { WorkOrderFilterForm } from '../../form-model/work-order-filter.form.model';
import { WorkOrderSearchTextForm } from '../../form-model/work-order-search-text.form.model';
import { createPopup } from '@maersk-global/insightshub-embed-common';
import { AuthHelper } from '../../auth/auth-helper';
import { environment } from '../../../environments/environment';

import { BulkWorkOrderCompletionBody } from '../../models/bulk-work-order/bulk-work-order-completion.model';
@Component({
  selector: 'app-work-order-list-page',
  imports: [SearchComponent, WorkOrderGridComponent, FiltersComponent, NgxSkeletonLoaderModule, ReactiveFormsModule],
  templateUrl: './list-work-orders.component.html',
  styleUrl: './list-work-orders.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ListWorkOrdersComponent {
  isAnyRowSelected: boolean = false; // Boolean to track selection of any row in the grid
  selectedRows: BulkWorkOrderCompletionBody[] = []; // Array to store selected rows
  surveyEnabled = environment.Features.EnableSus;
  filterFormGroup = this.formBuilder.group({
    workOrderFilterForm: this.formBuilder.group<WorkOrderFilterForm>({} as WorkOrderFilterForm),
    workOrderSearchTextForm: this.formBuilder.group<WorkOrderSearchTextForm>({} as WorkOrderSearchTextForm),
  });

  constructor(private formBuilder: FormBuilder) {}
  openSurvey() {
    const result = createPopup(environment.SUS_SURVEY_ID, { email: AuthHelper.user?.emailAddress, height: 600, width: 800 });
    result.open();
  }
  handleSelectedRows(selectedRowsChange: BulkWorkOrderCompletionBody[]) {
    this.selectedRows = selectedRowsChange;
  }
}
